@if (bannerState$ | async; as bannerState) {
  <div
    class="chat-connection-banner alert d-flex align-items-center justify-content-center gap-1"
    [class.alert-warning]="bannerState !== 'restored'"
    [class.alert-success]="bannerState === 'restored'"
    role="status"
    aria-live="polite"
  >
    @switch (bannerState) {
      @case ('offline') {
        <i class="ri-cloud-off-line"></i>
        <span>{{ 'chat.states.connectionLost' | translate }}</span>
      }
      @case ('reconnecting') {
        <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
        <span>{{ 'chat.states.reconnecting' | translate }}</span>
      }
      @case ('restored') {
        <i class="ri-cloud-line"></i>
        <span>{{ 'chat.states.connected' | translate }}</span>
      }
    }
  </div>
}
